import { Button, Stack, Typography } from "@mui/joy";
import useOpenTask from "hooks/useOpenTask";
import { useTranslation } from "react-i18next";
import { theme } from "../../styles/theme";

export default function PaymentModule({
  type,
}: {
  type: "expired" | "not_started";
}) {
  const openPayment = useOpenTask({ taskKey: `payment` });

  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });

  const text = {
    expired: {
      title: t_payment(`이용 기간이 만료되었어요`),
      subtitle: t_payment(`다시 결제하고 프로그램을 이어가세요.`),
    },
    not_started: {
      title: `결제 후 이용해주세요`,
      subtitle: `지금 코치 선생님과 100일 완성 프로그램을 시작하세요.`,
    },
  };

  return (
    <Stack
      sx={{
        width: "100%",
        backgroundColor: "white",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        spacing="32px"
        alignItems="center"
        sx={{
          width: "100%",
          maxWidth: "660px",
          mx: "auto",
          px: "24px",
          py: "16px",
        }}
      >
        <Stack spacing={"2px"}>
          <Typography
            variant="Body"
            sx={{
              color: theme.vars.palette.Content.Strong,
              fontWeight: 700,
              pr: 0,
            }}
          >
            {text[type].title}
          </Typography>
          <Typography
            variant="Caption"
            sx={{
              color: theme.vars.palette.Content.Weak,
              fontWeight: 500,
              pr: 0,
            }}
          >
            {text[type].subtitle}
          </Typography>
        </Stack>
        <Button
          size="sm"
          onClick={() => {
            openPayment();
          }}
          sx={{
            whiteSpace: "nowrap",
            minWidth: "auto",
          }}
        >
          {t_payment("더 알아보기")}
        </Button>
      </Stack>
    </Stack>
  );
}
